import { useState } from 'react';
import classNames from 'classnames';

import SvgIcon from '../../core/SvgIcon';

import useStyles from './styles';
import { ICollapsibleSidebarContent } from './types';

function CollapsibleSidebarContent({
  children,
  title,
  className,
  formatOptionClassName,
  element = 'h4',
}: ICollapsibleSidebarContent) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const classes = useStyles({
    collapsed: isCollapsed,
  });
  const Tag = element;
  return (
    <div className={className}>
      <div className={classNames(classes.formatOptions, formatOptionClassName)}>
        <Tag className={classes.title}>{title}</Tag>
        <SvgIcon
          className={classes.collapse}
          name={isCollapsed ? 'collapse-arrow-up-gen' : 'collapse-arrow-down-gen'}
          onClick={() => setIsCollapsed((prevIsCollapsed) => !prevIsCollapsed)}
        />
      </div>
      <div className={classes.collapsibleContainer}>{children}</div>
    </div>
  );
}
export default CollapsibleSidebarContent;
